export default __webpack_public_path__ + "static/media/Broadform-building-KID-2025.ebe3ace5.pdf";